import React from 'react';
import BayTooltip from '@bay-ui/BayTooltip';

export interface TooltipProps {
	content: React.ReactNode;
	children: React.ReactNode;
	placement?: string;
	trigger?: 'hover' | 'click';
	disabled?: boolean;
	delay?: number;
	overlayClassName?: string;
}

const placementMap: Record<string, string> = {
	top: 'top',
	'top-start': 'topLeft',
	'top-end': 'topRight',
	right: 'right',
	'right-start': 'rightTop',
	'right-end': 'rightBottom',
	bottom: 'bottom',
	'bottom-start': 'bottomLeft',
	'bottom-end': 'bottomRight',
	left: 'left',
	'left-start': 'leftTop',
	'left-end': 'leftBottom',
};

function mapPlacement(placement: string) {
	return placementMap[placement] ?? placement;
}

export function Tooltip({
	content,
	children,
	placement = 'bottom',
	trigger = 'hover',
	disabled = false,
	delay = 150,
	overlayClassName,
}: TooltipProps) {
	return (
		<BayTooltip
			overlay={content}
			placement={mapPlacement(placement)}
			trigger={trigger}
			disabled={disabled}
			overlayClassName={overlayClassName}
			mouseEnterDelay={delay / 1000}
			mouseLeaveDelay={Math.max(delay / 2000, 0)}
		>
			{children}
		</BayTooltip>
	);
}
